import { PessoaTipo } from "features/pessoas/typings";
import {
  FormaRecorrenciaEnum,
  OperacaoEnum,
  StatusBoletoEnum,
  TipoDivisaoContaEnum,
  TipoDocumentoEnum,
  TipoEntidadeEnum,
  TipoRecorrenciaEnum,
} from "core/resources/enums/conta";
import { FormaPagamento } from "core/resources/enums/tenant";
import { PaginateQuery } from "core/resources/types/shared";
import { OrigemContaEnum } from "core/features/cobranca/typings";

export interface ContaItemBase {
  id: string;
  descricao: string;
  valor: number;
  valorPago: number;
  valorLiquido: number;
  valorCorrecaoMonetaria: number;
  valorOriginal: number;
  multa: number;
  juros: number;
  desconto?: number | null;
  descontoValidoAte?: string | null;
  taxaCobranca: number;
  outrasTaxas: number;
  acordo?: boolean;
  tag: string;
  pessoa: string;
  pessoaPagador?: string;
  unidade: string;
  unidadeId: string;
  formaPagamentoId?: FormaPagamento;
  pessoaLiquidacaoId?: string;
  pagamentoDuplicado?: boolean;
  importado?: boolean;
  formasRecebimento?: {
    id: FormaPagamento;
    nome: string;
  }[];
  emailEnviado?: boolean;
  // categoria: string;
  dataVencimento: string;
  dataPagamento: string | null;
  dataMovimentacao: string | null;
  linkBoleto: string | null;
  diasEmAtraso: number;
  pagamentoManual?: boolean;
  tiposAnexosIds?: TipoAnexoContaEnum[];
  anexosTiposIds?: TipoAnexoContaEnum[];
}
export interface ContaItemResponse extends ContaItemBase {
  statusBoletoId?: StatusBoletoEnum;
  transferenciaId?: string | null;
  origemContaId?: OrigemContaEnum;
  contaRecorrenteId?: string;
  contaProtestoId?: string | null;
  cobrancaUnificadaId?: string | null;
}

export interface ContaParcela {
  id?: string;
  dataVencimento: string;
  descricao: string;
  valor: number;
  numeroParcela?: number;
}

export interface ContaAnexo {
  id?: string;
  nome: string;
  keyName?: string;
  bucket?: string;
  referencia: string;
  mimetype: string;
  temp?: boolean;
  tipoAnexoId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ComposicaoItem {
  valor?: number;
  categoriaFinanceiraId?: string;
  operacao?: OperacaoEnum;
  complemento?: string;
  centroDeCustoId?: string;
  categoriaFinanceira?: {
    breadcrumb: string;
    operacao: number;
    nome: string;
    id: string;
  };
}

export interface ContaForm {
  id?: string;
  tagId?: string | null;
  unidadeId?: string | null;
  gerarCobranca: boolean;
  calcularJurosAutomatico: boolean;
  juros: number;
  multa: number;

  valorTaxaCobranca: number;
  operacao: OperacaoEnum;
  descricao: string;
  dataVencimento: string;
  dataPagamento: string | null;
  dataCompetencia?: string | null;
  tipoEntidadeId: TipoEntidadeEnum;
  composicoes: ComposicaoItem[];
  pessoaId?: string;
  valor: number;
  tipoDocumentoId?: TipoDocumentoEnum;
  dataDocumento?: string;
  numeroDocumento?: string;
  serieNota?: string;
  tenantContaId: string;
  grupoConta?: string | null;
  tipoRecorrenciaId?: TipoRecorrenciaEnum;
  formaRecorrenciaId?: FormaRecorrenciaEnum;
  tipoDivisaoContaId?: TipoDivisaoContaEnum;
  formaPagamentoId?: FormaPagamento;
  formasRecebimentoIds?: FormaPagamento[];
  parcelas?: ContaParcela[];
  parcelasExistentes?: ContaParcela[];
  documentoFiscal: boolean;
  imposto: {
    issqn: number;
    irrf: number;
    pisConfisCsll: number;
    inss: number;
  };
  xml?: File;
  numeroCheque: string;
  retencaoImposto?: boolean;
  repetir?: boolean;
  numeroParcelas?: number;
  anexarArquivos?: boolean;
  files?: (
    | (File & { key?: string })
    | {
      id: string;
      referencia: string;
      mimetype: string;
      nome: string;
      tipoAnexoId?: string;
    }
  )[];

  anexos?: ContaAnexo[];
  arquivosExcluidos?: string[];
  pagarConta?: PagarContaForm;
  liquidarConta?: boolean;

  reterImpostos: boolean;
  retencoesImpostos: RetencaoImpostoItem[];
  pularChecagemDespesa?: boolean;
  tiposAnexosIds?: TipoAnexoContaEnum[];
}

export interface RetencaoImpostoItem {
  id?: string;
  impostoId: string;
  imposto?: {
    id: string;
    nome: string;
    codigo: string;
    aliquota: number;
  };
  valor: number;
  dataVencimento: string;
  reterImposto: boolean;
  complemento: string;
  codigoBarras: string;
}
export interface ContaDetalheResponse extends ContaForm {
  id: string;
  dataMovimentacao: string;
  observacao: string | null;
  tipoDivisaoContaId: TipoDivisaoContaEnum;
  formasRecebimento: {
    id: FormaPagamento;
    nome: string;
  }[];
  transferenciaId: string | null;
  valor: number;
  valorPago: number | null;
  total: number | null;
  valorCorrecaoMonetaria: number | null;
  numeroParcela: number | null;
  totalParcela: number | null;
  contaPaiId: string | null;
  imposto: {
    issqn: number;
    irrf: number;
    pisConfisCsll: number;
    inss: number;
  };
}

export interface TransferenciaDetalhesResponse {
  id: string;
  contaOrigem: {
    id: string;
    nome: string;
    agencia: string;
    conta: string;
    banco: string;
  };
  contaDestino: {
    id: string;
    nome: string;
    agencia: string;
    conta: string;
    banco: string;
  };
  valor: number;
  data: string;
  anexos: {
    id: string;
    nome: string;
    url: string;
    tipo: string;
  }[];
}

export interface ContaDetalheCompleteResponse extends ContaDetalheResponse {
  tag: string | null;
  unidade: {
    nome: string;
  };
  boleto: {
    linkBoleto: string;
  } | null;
  bancoContaBancaria: string;
  // centroDeCustoNome: string | null;
  pessoa: {
    nome: string;
    documento: string;
    tipoPessoa: PessoaTipo;
    id: string;
    imagemUrl: string | null;
  };
  pessoaPagador: {
    nome: string;
    documento: string;
    tipoPessoa: PessoaTipo;
    id: string;
    imagemUrl: string | null;
  } | null;
  totalLiquido: number;
  valorInicial: number;
  retencoes: ComposicaoItem[];
  totalRetencao: number;
}

export interface PagarContaForm {
  id: string;
  dataPagamento: string;
  dataMovimentacao: string;
  formaPagamentoId: FormaPagamento;
  valorPago: number;
  multa: number;
  juros: number;
  taxaAdicional: number;
  taxaRegistro: number;
  taxaAdicionalCategoriaId: string;
  taxaAdicionalCategoriaOperacao: OperacaoEnum;
  tenantContaId: string;
  valor: number;
  emitirRecibo?: boolean;
  anexarArquivos?: boolean;
  arquivo?: File;
  tipoArquivo?: string;
  files?: (
    | File
    | {
      id: string;
      referencia: string;
      mimetype: string;
      nome: string;
      tipoAnexoId?: string;
    }
  )[];

  arquivosExcluidos?: string[];
  anexos?: ContaAnexo[];
}

export interface UploadAnexosContaForm {
  id: string;
  tipoAnexoId: TipoAnexoContaEnum;
  anexos: { id: string; referencia: string; mimetype: string; nome: string }[];
  arquivosExcluidos?: string[];
}

export interface PagarMultiplasContasForm {
  dataPagamento: string;
  dataMovimentacao: string;
  formaPagamentoId: string;
  taxaAdicionalCategoriaId?: string;
  taxaAdicionalCategoriaOperacao?: OperacaoEnum;
  tenantContaId: string;
  contas: ContaPagarMultiplasContasForm[];
}

export interface ContaPagarMultiplasContasForm {
  id: string;
  desconto?: number;
  juros?: number;
  multa?: number;
  taxaAdicional?: number;
  valorPago?: number;
  valor: number;
}
export interface ContaTotais {
  pendente: { quantidade: number; valor: number };
  liquidada: { quantidade: number; valor: number };
  atraso: { quantidade: number; valor: number };
}

export type TipoDataConta =
  | "vencimento"
  | "competencia"
  | "liquidacao"
  | "movimentacao"
  | "geracao";
export interface ContaFiltroType extends PaginateQuery {
  operacao: OperacaoEnum;
  dataInicio?: string | null;
  dataFim?: string | null;
  search?: string;
  pago: boolean | null;
  atraso: boolean | null;
  acordo: number | null;
  cobrancaUnificada: number | null;
  pagamentoDuplicado: number | null;
  page: number;
  orderBy?: string;
  extratosBancariosIds?: string[];
  orderDirection?: "ASC" | "DESC" | null;
  naoConciliado?: "1" | null;
  conciliado?: "1" | null;
  tipoData?: TipoDataConta;
  unidadesIds?: string[];
  unidadeId?: string;
  pessoaId?: string;
  contasBancariasIds?: string[];
  centrosDeCustoIds?: string[];
  formasPagamentoIds?: string[];
  categoriasFinanceirasIds?: string[];
  statusBoletoId?: StatusBoletoEnum | "";
  contasRecorrentesIds?: string[] | null;
  // statusEmailId?: FiltroStatusEmail
  emailEnviado?: FiltroStatusEmail;
  contaId?: string | null;
  contemAnexoIds?: string | null;
  naoContemAnexoIds?: string | null;
  contasIds?: string[];
  tipoLiquidacao?: ContaTipoLiquidacao;
  gruposUnidadesIds?: string[];
}

export enum FiltroStatusEmail {
  Enviados = "1",
  NaoEnviados = "0",
}

export enum ContaTipoLiquidacao {
  Manual = "manual",
  Automatica = "automatica",
}

export interface GetEncargosResponse {
  juros: number;
  multa: number;
  taxaCobranca: number;
  taxaCobrancaCategoriaId: string;
  tenantIntegradoPagamentoOnline: boolean;
  taxaRegistroBoleto: number;
  taxaRegistroPix: number;
}

export interface ComposicaoContaListaForm {
  composicoes: ComposicaoItem[];
  calcularJurosAutomatico?: boolean;
  juros?: number | null;
  multa?: number | null;
  valorTaxaCobranca?: number | null;
  dataPagamento?: string | null;
}

export interface TableComposicaoContaData {
  composicoes: ComposicaoItem[];
  retencoes?: ComposicaoItem[];
  dataPagamento?: string | null;
  descontoValidoAte?: string;
  desconto?: number;
  valorInicial?: number;
  valorPago?: number | null;
  valorLiquido?: number | null;
  subtotal?: number | null;
  total?: number | null;
  valorCorrecaoMonetaria?: number | null;
  multa?: number;
  juros?: number;
  valorTaxaCobranca?: number;
  totalRetencao?: number;
}

export enum TipoAnexoContaEnum {
  DocumentoPagamento = "BAD477BD-0E21-4D0E-8AF4-092EC3CB0000",
  DocumentoFiscal = "BAD477BD-0E21-4D0E-8AF4-092EC3CB0001",
  Comprovante = "BAD477BD-0E21-4D0E-8AF4-092EC3CB0002",
  DocumentoAcessorio = "BAD477BD-0E21-4D0E-8AF4-092EC3CB0004",
  Outros = "BAD477BD-0E21-4D0E-8AF4-092EC3CB0003",
}

export const tagSetorJuridicoString = "Setor Jurídico";
